// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.account-menu{
  display:flex;
  color:#707070;
  -webkit-text-decoration:none;
  text-decoration:none;
  cursor:pointer;
  -webkit-user-select:none;
          user-select:none;
}
.account-menu:hover{
    color:#00429d;
  }
.account-menu{
  background-color:inherit;
  border:none;
}
.account-menu__name{
    display:none;
  }
@media (width > 640px){
.account-menu__name{
      display:inline-block;
      max-width:8rem;
      margin:0 0.5rem;
      font-weight:700;
      color:#424242;
      font-size:0.875rem;
      line-height:1.375rem;
      display:block;
      width:100%;
      overflow:hidden;
      text-overflow:ellipsis;
      white-space:nowrap
  }
    }
.account-menu__account{
    display:flex;
    color:#707070;
    -webkit-text-decoration:none;
    text-decoration:none;
    cursor:pointer;
    -webkit-user-select:none;
            user-select:none;
  }
.account-menu__account:hover{
    color:#00429d;
  }
.account-menu__account{
    color:#282828;
}
`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
